export const LIKE_COMMENT_FRAGMENT = `
  fragment LikeCommentFragment on Comment {
    id
    liked
    likeCount
  }
`;
